// removed by extract-text-webpack-plugin
module.exports = {"component":"tFj66S8OW_BamqyeRNy1o","container":"vh9zSz4oELFqeXk6bG8BS","backButton":"_1p-C34hLV315uCp9ektL1p","label":"_1e9WaagVUt7lUyJArGdet-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Forms/PrivateForms/FormButtons/FormBackButton/FormBackButton.css
// module id = 1408
// module chunks = 0